export const bikePassengerCode = 203
export const motorcyclePassengerCode = 202
export const carPassengerCode = 200